<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="vx-row">
                <div class="vx-col md:w-1/3 w-full mt-2">
                    <label class="vs-input--label">{{ this.$t('timeKeeping.branch') }}</label>
                    <v-select class="" v-model="selectedOrganizationBranch" :clearable="false"
                              :options="organizationBranchOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-2">
                    <label class="vs-input--label">{{ this.$t('timeKeeping.department') }}</label>
                    <v-select class="" v-model="selectedDepartment" :clearable="false" :options="departmentOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-2">
                    <label class="vs-input--label">{{ this.$t('timeKeeping.employee') }}</label>
                    <v-select class="" v-model="selectedEmployee" :clearable="false" :options="employeeOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>

                <div class="vx-col md:w-1/3 w-full mt-2">
                    <label class="vs-input--label">{{ this.$t('timeKeeping.alreadyCheckin') }}</label>
                    <v-select class="" v-model="selectedIsCheckIn" :clearable="false" :options="isCheckInOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>

                <div class="vx-col md:w-1/3 w-full mt-2">
                    <label class="vs-input--label">{{ this.$t('timeKeeping.late') }}</label>
                    <v-select class="" v-model="selectedIsLate" :clearable="false" :options="isLateOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-2">
                    <label class="vs-input--label">{{ this.$t('timeKeeping.times') }}</label>
                    <date-range-picker
                        class="w-full"
                        ref="picker"
                        :locale-data="{format: 'dd/mm/yyyy' }"
                        :opens="'left'"
                        @update="dateRangePicker"
                        v-model="dateRange">
                    </date-range-picker>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-6">
                    <vs-input class="w-full"
                              v-model="searchQuery"
                              @input="updateSearchQuery" :placeholder="$t('button.search')"/>
                </div>
                <div class="vx-col md:w-2/3 w-full mt-4">
                    <div class="flex flex-wrap items-center mt-2">
                        <vs-button class="mr-4" @click="search" :disabled="!validateForm" icon-pack="feather"
                                   icon="icon-search">
                            {{ this.$t('menuHistory.filter') }}
                        </vs-button>
                        <vs-button class="mr-4" @click="exportFile" :disabled="!validateForm" icon-pack="feather"
                                   icon="icon-file-plus" type="border"
                                   v-if="isPermissionAddReport()">{{ this.$t('timeKeeping.createReport') }}
                        </vs-button>
                        <vs-button class="" @click="$router.push('/user/history-file')"
                                   v-if="isPermissionAddReport()"
                                   icon-pack="feather" icon="icon-file-text" type="border">
                            {{ $t('timeKeeping.historyExport') }}
                        </vs-button>
                    </div>
                </div>
            </div>
            <!-- AgGrid Table -->
            <ag-grid-vue style="height: 55vh"
                         ref="agGridTable"
                         class="ag-theme-material w-100 my-4 ag-grid-table"
                         :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :rowData="workShiftData"
                         :animateRows="true"
                         :localeText=" {noRowsToShow: this.$t('menuCamera.noRowsToShow')} "
                         :paginationPageSize="pageSize"
                         :pagination="true"
                         @pagination-changed="onPaginationChanged"
                         @grid-ready="onGridReady"
                         :autoSizeStrategy="autoSizeStrategy"
                         tooltipShowDelay="0"
                         tooltipHideDelay="5000"
                         :tooltipMouseTrack="true">
            </ag-grid-vue>

            <div class="vx-row" v-if="totalElements > 0">
                <div class="vx-col md:w-1/2 w-full">
                    <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                        <span class="vx-col mt-2 flex items-center">Số phần tử / trang:</span>
                        <vs-dropdown vs-trigger-click class="cursor-pointer">
                            <div
                                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                                <span class="mr-2">
                                    {{
                                        countElementPage > totalElements ? totalElements : countElementPage
                                    }} / {{ totalElements }}</span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                            </div>
                            <vs-dropdown-menu>

                                <vs-dropdown-item @click="changePageSize(20)">
                                    <span>20</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSize(30)">
                                    <span>30</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSize(50)">
                                    <span>50</span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                    <vs-pagination :total="totalPages" v-model="currentPage" @input="loadPage"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import {AgGridVue} from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import moment from 'moment'; // Vuesax
import Pagination from "../../ui-elements/Pagination.vue"
import CellRendererActions from './cell-renderer/CellRendererActions.vue'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Datepicker from 'vuejs-datepicker';
import DateRangePicker from '../../../components/vue2-daterange-picker/components/DateRangePicker.vue'
import {isAPI} from '../../../store/permission';
import {constAPI} from '../../../store/constant';

export default {
    components: {
        AgGridVue,
        vSelect,
        Datepicker,
        Pagination,
        CellRendererActions,
        DateRangePicker,
        flatPickr,
    },
    data() {
        return {
            searchQuery: "",
            // AgGrid
            gridApi: null,
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: 'STT',
                    field: 'stt',
                    width: 100,
                    suppressSizeToFit: true,
                },
                {
                    headerName: this.$t('timeKeeping.employeeCode'),
                    field: 'employeeCode',
                    minWidth: 150,
                    tooltipField: 'employeeCode',
                },
                {
                    headerName: this.$t('timeKeeping.fullName'),
                    field: 'fullName',
                    minWidth: 200,
                    tooltipField: 'fullName',
                },
                {
                    headerName: this.$t('timeKeeping.shift'),
                    field: 'displayGroupName',
                    minWidth: 200,
                    tooltipField: 'displayGroupName',
                },
                {
                    headerName: this.$t('timeKeeping.date'),
                    field: 'date',
                    minWidth: 130,
                },
                {
                    headerName: this.$t('timeKeeping.onShift'),
                    field: 'checkinTime',
                    minWidth: 130,
                },
                {
                    headerName: this.$t('timeKeeping.afterWork'),
                    field: 'checkoutTime',
                    minWidth: 130,
                },
                {
                    headerName: this.$t('timeKeeping.typeCheckin'),
                    field: 'actionTypeName',
                    minWidth: 130,
                },
                {
                    headerName: this.$t('timeKeeping.actions'),
                    field: 'actions',
                    minWidth: 150,
                    cellRenderer: 'CellRendererActions',
                    pinned: 'right',
                },
            ],
            workShiftData: [],
            organizationBranchOptions: [],
            employeeOptions: [],
            selectedOrganizationBranchValue: null,
            selectedEmployeeValue: null,
            dateRange: {
                endDate: new Date(),
                startDate: (() => {
                    return new Date().setHours(0, 0, 0);
                })()
            },
            isCheckIn: null,
            isCheckInOptions: [
                {value: null, label: this.$t('menuOrganization.all')},
                {value: true, label: 'Đã chấm công'},
                {value: false, label: 'Chưa chấm công'}
            ],
            isLate: null,
            isLateOptions: [
                {value: null, label: this.$t('menuOrganization.all')},
                {value: true, label: 'Đi muộn'}
            ],
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            totalPages: 0,
            currentPage: 1,
            countElementPage: 0,
            totalElements: 0,
            departmentOptions: [],
            selectedDepartmentValue: null,
            pageSize: 50,
        }
    },
    async created() {
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]')
        if (branchList.length === 0) {
            return this.$vs.notify({
                text: 'Hiện tại không tồn tại chi nhánh nào',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        }
        this.organizationBranchOptions = branchList.filter(el => el.organizationBranchType !== 3).map(item => {
            return {value: item.id, label: item.organizationBranchName}
        })

        if (this.$route.query.isCheckin && this.$route.query.isCheckin === 'true') {
            this.selectedIsCheckIn = {value: true, label: 'Đã check in'};
        } else if (this.$route.query.isCheckin && this.$route.query.isCheckin === 'false') {
            this.selectedIsCheckIn = {value: false, label: 'Chưa check in'};
        }
        if (this.$route.query.employeeId) {
            this.selectedEmployeeValue = parseInt(this.$route.query.employeeId, 10);
            await this.getInfoEmployee();
            this.loadEmployee();
        }
        if (this.$route.query.isLate === 'true') {
            this.selectedIsLate = {value: true, label: 'Đi muộn'};
        }
        if (this.$route.query.theBestLate === 'true') {
            this.dateRange.startDate = new Date(new Date().setDate(new Date().getDate() - 1));
            this.dateRange.endDate = new Date(new Date().setDate(new Date().getDate() - 1));
        }

        let index = 0;
        if (this.selectedOrganizationBranch) {
            index = this.organizationBranchOptions.findIndex(item => item.value === this.selectedOrganizationBranch)
        }
        this.selectedOrganizationBranch = this.organizationBranchOptions[index > -1 ? index : 0];
        await this.filter()
    },
    watch: {
        async '$store.state.isUpdateCheckInCheckOut'(val) {
            if (val) {
                await this.filter();
                this.$store.commit('UPDATE_CHECKIN_CHECKOUT', false);
            }
        }
    },
    computed: {
        selectedOrganizationBranch: {
            get() {
                return {
                    label: this.organizationBranchString(this.selectedOrganizationBranchValue),
                    value: this.selectedOrganizationBranchValue
                }
            },
            async set(obj) {
                this.selectedOrganizationBranchValue = obj.value;
                await this.loadDepartment();
                this.loadEmployee();
            }
        },
        selectedDepartment: {
            get() {
                let obj = this.departmentOptions.find(el => el.value === this.selectedDepartmentValue);
                if (!obj) return;
                return {
                    label: obj.label,
                    value: obj.value,
                }
            },
            set(obj) {
                this.selectedDepartmentValue = obj ? obj.value : null;
                this.loadEmployee();
            }
        },
        selectedEmployee: {
            get() {
                let obj = this.employeeOptions.find(el => el.value === this.selectedEmployeeValue);
                if (!obj) return;
                return {
                    label: obj.label,
                    value: obj.value,
                }
            },
            set(obj) {
                this.selectedEmployeeValue = obj ? obj.value : null;
            }
        },
        selectedIsCheckIn: {
            get() {
                return {
                    label: this.isCheckinString(this.isCheckIn),
                    value: this.isCheckIn
                }
            },
            set(obj) {
                this.isCheckIn = obj.value
            }
        },
        selectedIsLate: {
            get() {
                return {
                    label: this.isLateString(this.isLate),
                    value: this.isLate
                }
            },
            set(obj) {
                this.isLate = obj.value
            }
        }
    },
    methods: {
        isPermissionAddReport() {
            return isAPI(this, constAPI.time_keeping_export)
        },
        dateRangePicker: function () {
            this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59));
        },
        updateSearchQuery(val) {
            this.gridApi.setGridOption('quickFilterText', val);
            if (val) {
                this.totalElements = this.gridApi.getDisplayedRowCount()
            } else {
                this.totalElements = this.workShiftData.length
            }
        },
        organizationBranchString(id) {
            let organizationBranch = this.organizationBranchOptions.find(x => x.value === id);
            return (organizationBranch && organizationBranch.label) || 'xác định';
        },
        isCheckinString(id) {
            let isCheckIn = this.isCheckInOptions.find(x => x.value === id);
            return (isCheckIn && isCheckIn.label) || 'Chưa xác định';
        },
        isLateString(id) {
            let isLate = this.isLateOptions.find(x => x.value === id);
            return (isLate && isLate.label) || 'Chưa xác định';
        },
        addEmployee() {
            this.$router.push(`/user/add-employee?branch_id=${this.selectedOrganizationBranchValue}`).catch(() => {
            });
        },
        validateForm() {
            return !this.errors.any()
        },
        filter() {
            return new Promise((resolve, reject) => {
                let searchInfo = {
                    organizationBranchId: this.selectedOrganizationBranchValue,
                    departmentId: this.selectedDepartmentValue,
                    employeeId: this.selectedEmployeeValue ? [this.selectedEmployeeValue] : null,
                    start: moment(this.dateRange.startDate).set({hour: 0, minute: 0, second: 0, millisecond: 0}),
                    end: moment(this.dateRange.endDate).set({hour: 23, minute: 59, second: 59, millisecond: 59}),
                    isCheckIn: this.isCheckIn,
                    isLate: this.isLate,
                }
                this.$vs.loading();
                this.$crm.post('/time-keeping/find', searchInfo).then((response) => {
                    let workShiftData = response.data.sort((item1, item2) => {
                        if (moment(item1.date) > moment(item2.date)) return 1;
                        if (moment(item1.date) < moment(item2.date)) return -1;
                    })
                    this.workShiftData = workShiftData.map(item => {
                        item.stt = this.pageSize * (this.currentPage - 1) + response.data.indexOf(item) + 1;
                        item.displayGroupName = item.groupName + " - " + item.workShiftName;
                        let employee = this.employeeOptions.find(x => x.employeeCode === item.employeeCode);
                        item.employeeId = employee ? employee.value : null;

                        item.branchId = this.selectedOrganizationBranchValue;
                        item.actionTypeName = '';
                        if (item.actionType) {
                            switch (item.actionType) {
                                case 0:
                                    item.actionTypeName = 'CameraAI';
                                    break;
                                case 1:
                                    item.actionTypeName = 'Wifi';
                                    break;
                                case 2:
                                    item.actionTypeName = 'QR Code';
                                    break;
                                case 3:
                                    item.actionTypeName = 'Quản lý duyệt';
                                    break;
                                case 4:
                                    item.actionTypeName = 'Khiếu nại chấm công';
                                    break;
                                case 5:
                                    item.actionTypeName = 'Chấm công từ xa';
                                    break;
                                case 6:
                                    item.actionTypeName = 'Pad';
                                    break;
                                default:
                                    break;
                            }
                        }
                        return item;
                    })
                    this.workShiftData = this.workShiftData.filter(x => x.employeeId);
                    this.countElementPage = this.currentPage * this.pageSize;
                    this.totalElements = this.workShiftData.length;
                    resolve(response)
                    this.$vs.loading.close();
                }).catch((err) => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        exportFile() {
            if (this.workShiftData.length === 0) {
                return this.$vs.notify({
                    title: this.$t('message.error'),
                    text: 'Không có nhân viên nào !',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            } else {
                // eslint-disable-next-line no-unused-vars
                // let branchId;
                // let userInfo = JSON.parse(localStorage.getItem('userInfo'));
                // if (userInfo.userRole !== 'organization') branchId = this.valueSelectedBranch ? this.valueSelectedBranch : userInfo.organizationBranchId;
                // else branchId = this.valueSelectedBranch;
                let searchInfo = {
                    organizationBranchId: this.selectedOrganizationBranchValue,
                    employeeId: this.selectedEmployee.value ? [this.selectedEmployee.value] : null,
                    start: moment(this.dateRange.startDate).set({hour: 0, minute: 0, second: 0, millisecond: 0}),
                    end: moment(this.dateRange.endDate).set({hour: 23, minute: 59, second: 59, millisecond: 59}),
                    isCheckIn: this.isCheckIn,
                    isLate: this.isLate,
                    departmentId: this.selectedDepartmentValue,
                    isStudent: false,
                };
                this.$vs.loading();
                let url = searchInfo.employeeId ? '/time-keeping/create' : '/report-file/export-file'
                this.$crm.post(url, searchInfo).then(() => {
                    this.$vs.loading.close();
                    this.$router.push('/user/history-file');
                    // if (payload.employeeId) window.open(authConfig.crmDomain + "file/" + response.data.fileName + "?access_token=" + localStorage.getItem("access_token"), "_blank");
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: this.$t('message.error'),
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            }
        },
        onGridReady(params) {
            this.gridApi = params.api;
        },

        onPaginationChanged() {
            if (this.gridApi) {
                this.totalPages = this.gridApi.paginationGetTotalPages();
            }
        },
        loadPage: function (currentPage) {
            if (this.gridApi) this.gridApi.paginationGoToPage(currentPage - 1)
        },
        loadEmployee() {
            if (!this.selectedOrganizationBranchValue) return;
            let payload = {
                enable: true,
                departmentId: this.selectedDepartmentValue,
                organizationBranchId: this.selectedOrganizationBranchValue,
            }
            this.$vs.loading();
            this.$crm.post('/employee/all', payload).then((response) => {
                this.$vs.loading.close();
                if (response.data && response.data.length > 0) {
                    this.employeeOptions = response.data.map(item => {
                        return {
                            value: item.employeeId,
                            label: item.employeeCode + "_" + item.fullName,
                            employeeCode: item.employeeCode
                        }
                    });
                } else {
                    this.employeeOptions = [];
                }
                if (this.employeeOptions.length > 0 && this.selectedEmployeeValue) {
                    this.selectedEmployee = this.employeeOptions.find(x => x.value === this.selectedEmployeeValue);
                }
                this.employeeOptions.unshift({value: null, label: this.$t('menuOrganization.all')})
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Có lỗi sảy ra!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        getInfoEmployee() {
            return new Promise((resolve) => {
                this.$vs.loading();
                this.$crm.post('/employee/find-by-id/' + this.selectedEmployeeValue).then((response) => {
                    this.selectedOrganizationBranchValue = response.data.organizationBranchId;
                    resolve();
                    this.$vs.loading.close();
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        async search() {
            this.currentPage = 1;
            if (this.gridApi) this.gridApi.paginationGoToPage(this.currentPage - 1)
            await this.filter();
        },

        loadDepartment() {
            return new Promise((resolve, reject) => {
                let payload = {
                    organizationBranchId: this.selectedOrganizationBranchValue
                };

                this.$vs.loading();
                this.$crm.post('/department/find-by-condition', payload).then(res => {
                    if (res.data && res.data.length > 0) {
                        this.departmentOptions = res.data.map(el => {
                            return {
                                value: el.id,
                                label: el.departmentName,
                            }
                        })
                    } else {
                        this.departmentOptions = [];
                    }
                    this.departmentOptions.unshift({value: null, label: this.$t('menuOrganization.all')});
                    resolve(res)
                    this.$vs.loading.close();
                }).catch((err) => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        changePageSize(number) {
            this.pageSize = number;
            this.onPaginationChanged();
            this.currentPage = 1;
            this.countElementPage = this.currentPage * this.pageSize;
            // this.search();
        },
    },
}
</script>

<style lang="scss">
.ag-paging-panel {
    display: none;
}
</style>
